module.exports = __webpack_public_path__ + "gh.svg?5460b9ab61f03f0609e28b84f2fc9a69";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gh.svg
// module id = 1064
// module chunks = 27